import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RoleManagerService } from '../role-manager.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-role-add',
  templateUrl: './role-add.component.html',
  styleUrls: ['./role-add.component.scss']
})
export class RoleAddComponent {
  buttonDisabled = true;
  loader: boolean = false;
  allRead: any;
  allWrite: any;
  rowData: any[] = [];
  roleRightsJson: any[] = [];
  usertypes: any[] = [];
  user_profile: any;
  newRole: any;
  profile: any;
  mainIndex: number;
  subIndex: number;
  selectedActions: any;
  selectedTitle: any;
  error: string;
  currentUser: any;
  roleVisibility = false;
  constructor(public dialogRef: MatDialogRef<RoleAddComponent>,
    private roleManagerService: RoleManagerService,
    private modalService: NgbModal,
    private toast: ToastrService) { }

  closePopup() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
        this.getcurrentUser().then((res:any)=>{
      console.log(res);
      this.currentUser = res?.result?._source?.user_type;
           this.getList();
    })
  }
  changeUserType(e) {
    if (e) {
      let obj = this.usertypes.filter(o => o.id == e);
      this.profile = obj[0].profile;
      this.getRolesDetails();
    } else {
      this.roleRightsJson = [];
      this.allRead = false;
      this.allWrite = false;
      this.buttonDisabled = true;
    }
  }

    getcurrentUser() {
    return new Promise((resolve, reject)=>{
    this.roleManagerService.getCurrentUser().subscribe({next:(data: any) => {
      resolve(data);
    },
    error: (err: any) => {
      resolve({});
    }
  })
  })
  }

  getList() {
    this.loader = true;
    this.roleManagerService.getAllRoles().subscribe((data: any) => {
      this.rowData = data.result.hits;
      let offData = [];
      this.rowData.map((item: any) => {
        if (item._source.type == 'user_role') {
          if(this.currentUser=="admin"||item._source.visibility){
                    offData.push({
            id: item._id,
            name: this.camalize(item._id),
            profile: item._source.profileIds
          })
          }
  
        }
      }
      )
      this.usertypes = offData;
      this.loader = false;
    }, err => {
      this.loader = false;

    })
  }
  camalize(mySentence: any) {
    return mySentence.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  }

  getRolesDetails() {
    this.loader = true;
    this.roleManagerService.getRoleDetails(this.user_profile).subscribe((result: any) => {
      this.loader = false;
      this.roleRightsJson = result.result._source.pages;
      this.roleRightsJson.map((item: any, index: any) => {
        this.checkAllRead(index);
        this.checkAllWrite(index);
      })
      this.allRead = this.roleRightsJson.every(v => v.read == true);
      this.allWrite = this.roleRightsJson.every(v => v.write == true);
      this.newRole ? this.buttonDisabled = false: this.buttonDisabled = true;
    }, err => {
      this.loader = false;

    })
  }
  checkAllRead(mainIndex) {
    this.roleRightsJson[mainIndex].read = this.roleRightsJson[mainIndex]?.data.every(v => v.read == true);
  }
  checkAllWrite(mainIndex) {
    this.roleRightsJson[mainIndex].write = this.roleRightsJson[mainIndex].data.every(v => v.write == true);
  }
  onMouseClick(e: any) {
    e.stopPropagation()
  }
  onMouseClick1(e: any) {
    e.stopPropagation()
  }
  setReadCheckbox(mainIndex: number, subIndex: number, right: boolean) {
    this.roleRightsJson[mainIndex].data[subIndex].read = right;
    this.checkAllRead(mainIndex);
  }
  setWriteCheckbox(mainIndex: number, subIndex: number, right: boolean) {
    this.roleRightsJson[mainIndex].data[subIndex].write = right;
    this.checkAllWrite(mainIndex);
  }
  setAllReadCheckbox(mainIndex: number, right: boolean) {
    this.roleRightsJson[mainIndex].read = right;
    this.roleRightsJson[mainIndex].data.map((item: any) => {
      item.read = right;
    })
    this.checkAllRead(mainIndex);
  }
  setAllWriteCheckbox(mainIndex: number, right: boolean) {
    this.roleRightsJson[mainIndex].write = right;
    this.roleRightsJson[mainIndex].data.map((item: any) => {
      item.write = right;
    })
    this.checkAllWrite(mainIndex);
  }
  setOverAllWriteCheckbox(right) {
    this.allWrite = right;
    this.roleRightsJson.map((item: any, index: any) => {
      this.setAllWriteCheckbox(index, right)
    })
  }
  setOverAllReadCheckbox(right) {
    this.allRead = right
    this.roleRightsJson.map((item: any, index: any) => {
      this.setAllReadCheckbox(index, right)
    })
  }

  changeVisibility(){
    this.roleVisibility = !this.roleVisibility;
  }

  changeRoleName(e) {
    if (!this.newRole) {
      this.buttonDisabled = true;
    } else {
      const uniqueness = this.usertypes.filter(o => o.id?.toLowerCase() == this.newRole?.toLowerCase());
      if ( uniqueness.length > 0) {
        this.buttonDisabled = true;
        this.error = "Profile Name Already Exists";
      } else {
        this.error = "";	
        this.roleRightsJson.length > 0 ? this.buttonDisabled = false : this.buttonDisabled = true;
      }
    }
  }
  submit() {
    this.buttonDisabled = true;
    let body = {
      "type": "user_role",
      "pages": this.roleRightsJson,
      "profileIds": this.profile,
      visibility:this.roleVisibility
    }
    console.log(JSON.stringify(body))
    this.roleManagerService.roleCreate(body, this.newRole)
    .subscribe((result: any) => {
      this.toast.success("Role Rights are Created Successfully");
      this.dialogRef.close();
    })
  }
  validateName(e) {  //to stop entering the special charators except -

    var k;
    k = e.charCode;    //  k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  onCopyActionButtonClick(mainIndex: number, subIndex: number, template): void {
    this.mainIndex = mainIndex;
    this.subIndex = subIndex;
    const selectedItem = this.roleRightsJson[mainIndex].data[subIndex];
    this.selectedTitle = selectedItem.title;
    this.selectedActions = selectedItem.actions || [];
    this.modalService.open(template, { backdrop: 'static', size: 'sm',windowClass: "custom-modal-zindex ", keyboard: false });
  }
  onReadCheckboxChange(index: number, event: any) {
    this.selectedActions[index].read = event.target.checked;
    this.roleRightsJson[this.mainIndex].data[this.subIndex].actions = this.selectedActions;
    console.log(this.roleRightsJson);

  }

}